import { useNavigate } from 'react-router';

import { AuthShell, AuthHeading } from 'src/components/Layout';
import { OrganizationFormContainer } from 'src/containers/Organization';
import { apolloClient as client } from 'src/graphql';
import { CompanyDocument, type ICompanyQuery } from 'src/graphql/actions/company/company.query';
import { usePageMeta } from 'src/hooks';

const OnboardingOrganizationPage = () => {
  usePageMeta('Onboarding Organization');
  const navigate = useNavigate();
  const data = client.readQuery<ICompanyQuery>({ query: CompanyDocument });

  const successCallback = () => {
    if (!data?.company.policy.createUser) navigate('/');
    else navigate('/onboarding/invite');
  };

  return (
    <AuthShell wide>
      <AuthHeading
        title="Tell us about your organization"
        description="We use this information for account setup, legal agreements, notifications, and our records."
      />
      <OrganizationFormContainer
        successCallback={successCallback}
        submitBtnText="Save and continue"
        classes={{ footer: 'justify-center mt-4', submitBtn: 'w-full h-10 text-sm' }}
      />
    </AuthShell>
  );
};

export default OnboardingOrganizationPage;
